module.exports = __webpack_public_path__ + "static/img/team1-03.6dc2c7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team1-03.jpg
// module id = F2BC
// module chunks = 1